import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import NotFoundPage from "src/components/pages/NotFound"

export default (
  <Route>
    <BaseLayout title="404">
      <Switch>
        <Redirect exact from="/" to="/calendar" />
        <Route>
          <NotFoundPage />
        </Route>
      </Switch>
    </BaseLayout>
  </Route>
)
